<div class="content">
    <img [src]="data.imgUrl | cdn" alt="">
</div>

<div class="margin-top lg flex end">
    <button class="bee-button secondary" (click)="close()">Close</button>
</div>